import apiClient from '../client';
import { ApiResponse } from '@/types';

export interface ReportParams {
  dateType?: 'today' | 'yesterday' | 'thisWeek' | 'pastWeek' | 'thisMonth' | 'lastMonth' | 'thisYear' | 'custom' | 'all';
  fromDate?: string;
  toDate?: string;
  date?: string;
  timeRange?: string;
  userId?: string;
}

export interface DayEndReportData {
  reports: Array<{
    _id: string;
    client: { _id: string; name: string };
    task: string;
    subTask: string;
    allottedTo: { _id: string; name: string };
    teamLeader: { _id: string; name: string };
    priority: string;
    dueDate: string;
    frequency: string;
    status: string;
    tt: number;
    et: number;
    userId: string;
    userName: string;
  }>;
  summary: {
    totalTasks: number;
    totalTime: number;
    completedTasks: number;
    inProgressTasks: number;
  };
}

export interface ClientReportData {
  clients: Array<{
    _id: string;
    clientName: string;
    totalTasks: number;
    totalSubTasks: number;
    totalEstimatedTime: number;
    totalActualTime: number;
  }>;
  totals: {
    clients: number;
    tasks: number;
    subTasks: number;
    estimatedTime: number;
    actualTime: number;
  };
}

export interface UserReportData {
  users: Array<{
    _id: string;
    userName: string;
    totalTasks: number;
    totalSubTasks: number;
    totalEstimatedTime: number;
    totalActualTime: number;
  }>;
  totals: {
    users: number;
    tasks: number;
    subTasks: number;
    estimatedTime: number;
    actualTime: number;
  };
}

export interface TaskReportData {
  tasks: Array<{
    _id: string;
    totalSubTasks: number;
    totalEstimatedTime: number;
    totalActualTime: number;
  }>;
  totals: {
    tasks: number;
    subTasks: number;
    estimatedTime: number;
    actualTime: number;
  };
}

export interface SubTaskReportData {
  subTasks: Array<{
    subTask: string;
    task: string;
    totalEstimatedTime: number;
    totalActualTime: number;
  }>;
  totals: {
    subTasks: number;
    estimatedTime: number;
    actualTime: number;
  };
}

export const reportsApi = {
  getDayEndReport: (params?: ReportParams) => 
    apiClient.get<ApiResponse<DayEndReportData>>('/reports/day-end', { params }),
  
  getClientsReport: (params?: ReportParams) => 
    apiClient.get<ApiResponse<ClientReportData>>('/reports/clients', { params }),
  
  getUsersReport: (params?: ReportParams) => 
    apiClient.get<ApiResponse<UserReportData>>('/reports/users', { params }),
  
  getTasksReport: (params?: ReportParams) => 
    apiClient.get<ApiResponse<TaskReportData>>('/reports/tasks', { params }),
  
  getSubTasksReport: (params?: ReportParams) => 
    apiClient.get<ApiResponse<SubTaskReportData>>('/reports/sub-tasks', { params }),
  
  exportReport: (type: string, params?: ReportParams) => 
    apiClient.get(`/reports/export/${type}`, { 
      params: { ...params, format: 'excel' },
      responseType: 'blob' 
    }),
};